import React from 'react';
import type { AfcSubmissionCandidateOpportunity } from '@axiom/validation';
import {
  CandidateAccolades,
  CandidatePerformanceFeedback,
  Card,
  CardHeader,
  CardSection,
  Gutter,
  Layout,
  LayoutItem,
  Paragraph,
  SmallHeader,
  Well,
} from '@axiom/ui';

import ProfileCheckmark from '../../public/svg/profile-checkmark.svg';

type CandidateReputationProps = {
  candidateOpp: AfcSubmissionCandidateOpportunity;
};

export const CandidateReputation = ({
  candidateOpp,
}: CandidateReputationProps) => {
  const { candidate, showCandidateReputation } = candidateOpp;
  const { candidateReputation, showReputation } = candidate;
  const { displayCandidateReputation } = candidateReputation ?? {};
  const showRep = showReputation === true || showReputation === null;

  const setDisplay = () => {
    if (displayCandidateReputation && showCandidateReputation && showRep) {
      return (
        <Gutter top="24px">
          <CandidatePerformanceFeedback
            candidateReputation={candidateReputation}
          />
        </Gutter>
      );
    }

    if (!displayCandidateReputation && showCandidateReputation && showRep) {
      return (
        <Gutter top="24px">
          <Well background="light blue" name="limitedFeedbackDisplay">
            <Layout horizontalGutter="16px" position="middle">
              <LayoutItem>
                <ProfileCheckmark width="98" height="93" />
              </LayoutItem>
              <Paragraph>
                Although client feedback is not yet available for this talent,
                we are confident they are a great match for your legal needs.
              </Paragraph>
            </Layout>
          </Well>
        </Gutter>
      );
    }

    if (showCandidateReputation && !showRep) {
      return (
        <Gutter top="24px">
          <Well background="light blue" name="optedOutDisplay">
            <Paragraph>
              {candidate.calculatedDisplayName ?? 'Talent'} has chosen not to
              display client feedback.
            </Paragraph>
          </Well>
        </Gutter>
      );
    }

    return null;
  };

  return (
    <Card name="PERFORMANCE">
      <CardHeader>
        <SmallHeader>Axiom Performance</SmallHeader>
      </CardHeader>
      <CardSection>
        <Layout direction="vertical">
          <CandidateAccolades candidateReputation={candidateReputation} />
          {setDisplay()}
        </Layout>
      </CardSection>
    </Card>
  );
};
